module.exports = __webpack_public_path__ + "img/lc.1c3a5554.svg";